export const ActiveFlights = {
  namespaced: true,
  state: {
    flights: []
  },
  mutations: {
    flights(state, flights) {
      state.flights = flights;
    },
    flightOverride(state, override) {
      const index = state.flights.findIndex(flight => flight.id == override.id);
      state.flights.splice(index, 1, override);
    }
  },
  getters: {
    flights: state => {
      return state.flights;
    }
  }
};